import { Button as PrimeButton } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import type { ReactNode } from 'react';
import { Button } from '../../Button/Button';
import { Icon } from '../../Icon/Icon';
import type { ConfirmCloseConfig } from '../types';

interface CloseConfirmationDialogProps {
    visible: boolean;
    config: ConfirmCloseConfig;
    onCancel: () => void;
    onConfirm: () => void;
}

export function CloseConfirmationDialog({
    visible,
    config,
    onCancel,
    onConfirm,
}: CloseConfirmationDialogProps): ReactNode {
    const {
        title,
        dialogName,
        confirmLabel = 'Discard & Close',
        cancelLabel = 'Cancel',
    } = config;

    function HeaderContent(): ReactNode {
        return (
            <div className="flex flex-row justify-content-between align-items-center w-full">
                <div className="flex align-items-center">{title}</div>
                <Button
                    icon={<Icon name="cancel" fontSize="normal" />}
                    rounded
                    text
                    className="button-size-small"
                    onClick={onCancel}
                />
            </div>
        );
    }

    return (
        <Dialog
            visible={visible}
            modal
            draggable={false}
            header={<HeaderContent />}
            closable={false}
            className="dialog-close-confirmation"
            onHide={onCancel}
        >
            <p className="mt-0 mb-4">
                You have unsaved changes in <strong>{dialogName}</strong>.
                Closing this window will discard them.
            </p>
            <div className="flex gap-2 justify-content-end">
                <PrimeButton
                    label={cancelLabel}
                    severity="secondary"
                    onClick={onCancel}
                />
                <Button label={confirmLabel} onClick={onConfirm} />
            </div>
        </Dialog>
    );
}
